import { render, staticRenderFns } from "./ContentWrap.vue?vue&type=template&id=5f2cf937&"
import script from "./ContentWrap.vue?vue&type=script&lang=js&"
export * from "./ContentWrap.vue?vue&type=script&lang=js&"
import style0 from "./ContentWrap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports